import type { ListItem } from "../../components/List/List"
import { EEnableStatusType } from "../../Enum/EEnableStatusType"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPercent, faTicket, faUsers } from "@fortawesome/free-solid-svg-icons"
import { CouponEntity } from "../Coupon/CouponEntity"
import { MemoryClass } from "./MemoryClass"

export class CouponMemory extends MemoryClass<CouponEntity> {
  setList = (couponsList: CouponEntity[]) => {
    this.listData = couponsList
  }

  protected cloneEntity(item: CouponEntity): CouponEntity {
    return new CouponEntity({ ...item })
  }

  protected getItemId(item: CouponEntity): number {
    return item.id
  }

  getListCards = (): ListItem[] => this.listData.map((coupon, index) => this.getCard(coupon, index))

  getCard(coupon: CouponEntity, index: number): ListItem {
    const enable = coupon.status === EEnableStatusType.Active
    const createdAtDate = coupon.createdAt ? new Date(coupon.createdAt) : null
    const hasValidCreatedAt = Boolean(createdAtDate && !Number.isNaN(createdAtDate.getTime()))

    return {
      id: coupon.id,
      isDisable: !enable,
      index,
      title: coupon.code,
      linkImage: "",
      dataFilter: [
        coupon.code,
        coupon.discountPercentage.toString(),
        coupon.hasPerCustomerUsageLimit ? "limite por usuário" : "sem limite por usuário",
        coupon.hasGlobalUsageLimit ? "limite global" : "sem limite global",
      ],
      children: (
        <div
          className={`
            flex flex-col gap-3
            p-4
            rounded-2xl
            transition-all duration-300
            ${
              enable
                ? "bg-gradient-to-r from-orange-50 to-white hover:shadow-lg hover:scale-[1.01]"
                : "bg-gray-100 opacity-70"
            }
          `}
        >
          <div className="flex items-start justify-between gap-3">
            <div className="flex gap-3 min-w-0">
              <div className="w-12 h-12 rounded-xl bg-red-200 text-red-600 flex items-center justify-center shrink-0">
                <FontAwesomeIcon icon={faTicket} />
              </div>

              <div className="flex flex-col min-w-0">
                <span className="text-base font-black text-gray-900 uppercase truncate">{coupon.code}</span>
                <span className="text-2xl font-black text-orange-700 flex items-center gap-2">
                  <FontAwesomeIcon icon={faPercent} className="text-sm" />
                  {coupon.discountPercentage}% OFF
                </span>
              </div>
            </div>

            <span
              className={`px-3 py-1 text-xs font-bold rounded-full whitespace-nowrap ${
                enable ? "bg-green-100 text-green-700" : "bg-red-100 text-red-600"
              }`}
            >
              {enable ? "Ativo" : "Inativo"}
            </span>
          </div>

          <div className="border-t border-gray-200 pt-3 grid gap-1 text-xs text-gray-700 font-semibold">
            <span className="flex items-center gap-2 ">
              <FontAwesomeIcon icon={faUsers} className="text-gray-500" />
              {coupon.hasPerCustomerUsageLimit ? `Usuário: ${coupon.maxUsagePerCustomer}` : "Usuário: sem limite"}
            </span>
            <span className="flex items-center gap-2">
              <FontAwesomeIcon icon={faTicket} className="text-gray-500" />
              {coupon.hasGlobalUsageLimit ? `Global: ${coupon.maxUsageTotal}` : "Global: sem limite"}
            </span>

            {hasValidCreatedAt && (
              <span className="px-2 py-1 mt-1 w-fit rounded-full bg-indigo-100 text-indigo-700 font-medium">
                Criado em {createdAtDate!.toLocaleDateString()}
              </span>
            )}
          </div>
        </div>
      ),
    }
  }
}
